import modalsSelector from 'selectors/modals/modalsSelector';
import { createSelector } from 'reselect';
import Empty from 'constants/empty';

const skuToEditSelector = createSelector(modalsSelector, modals => modals.skuToEdit || Empty.Object);

export default skuToEditSelector;
